<template>
  <div class="nav-bottom">
    <div
      :class="[ navActive(section1) ? 'active-view' : 'inactive-view' ]"
      @click="goToPlanning">
      <img
        src="../assets/agenda.svg"
        alt="timesheet"
        :height="navActive(section1) ? minIcon : maxIcon"/>
      <p>{{ navActive(section1) ? $t('navigation.timesheet') : '' }}</p>
    </div>
    <div
      v-if="isSuperAdmin"
      :class="[ navActive(section2) ? 'active-view' : 'inactive-view' ]"
      @click="goToSurvey">
       <img
        src="../assets/lamp.svg"
        alt="share"
        :height="navActive(section2) ? minIcon : maxIcon"/>
      <p>{{ navActive(section2) ? $t('navigation.share') : '' }}</p>
    </div>
    <div
      :class="[ navActive(section3) ? 'active-view' : 'inactive-view' ]"
      @click="goToSettings">
      <img
        src="../assets/settings.svg"
        alt="settings"
        :height="navActive(section3) ? minIcon : maxIcon"/>
      <p>{{ navActive(section3) ? $t('navigation.settings') : '' }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      maxIcon: '100%',
      minIcon: '70%',
      section1: ['timesheet', 'edit-time-row', 'create-time-row'],
      section2: ['survey-share', 'survey-form'],
      section3: ['settings'],
      isSuperAdmin: false,
    };
  },
  created() {
    this.isSuperAdmin = this.$store.getters.isSuperAdmin;
  },
  methods: {
    goToPlanning() {
      this.$router.push({ path: '/index.html' });
    },
    goToSurvey() {
      this.$router.push({ path: '/surveyform' });
    },
    goToSettings() {
      this.$router.push({ path: '/settings' });
    },
    navActive(d) {
      return d.includes(this.$route.name);
    },
  },
};
</script>

<style scoped>
  p {
    margin: 0;
    margin-top: -6px;
    font-size: 12px;
  }

  .nav-bottom {
    display: flex;
    position: fixed;
    justify-content: space-around;
    background: #ffffff;
    max-height: 7vh;
    bottom: 0;
    padding-top: 1vh;
    padding-bottom: 1vh;
    width: 100%;
    box-shadow: 3px 0px 5px 0px;
    z-index: 1000;
  }

  .nav-bottom > div {
    min-width: 33%;
  }

  .active-view {
    opacity: 1;
  }

  .inactive-view {
    opacity: 0.5;
  }
</style>
